exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "input[type=number]{-moz-appearance:textfield}input::placeholder{color:#959595;font-size:16px;font-weight:100}input::-webkit-outer-spin-button,input::-webkit-inner-spin-button{-webkit-appearance:none;display:none;margin:0}", ""]);

// exports
